import React from 'react';
import { Layout } from '../components/Layout/Layout';
import { ActivityReports } from '../components/Advisor/ActivityReports';

export const AdvisorReportsPage: React.FC = () => {
  return (
    <Layout>
      <div className="p-6">
        <ActivityReports />
      </div>
    </Layout>
  );
};